<template>
  <div>
    <div class="ready_banner">
      <p class="ready_banner_top">{{examPaperInfo.title}}</p>
      <div class="ready_banner_bottom">
        <p class="mb30">考试内容简介：<span v-html="examPaperInfo.description"></span></p>
        <p>合格标准：满分{{examPaperInfo.score}}分，{{examPaperInfo.passline}}分及格</p>
        <p>考试时长：{{examPaperInfo.time}}分钟</p>
        <p>考题数量：{{examPaperQInfo.length}}题</p>
        <p class="kaoshi_price">费用：<span>￥{{parseFloat(examPaperInfo.point).toFixed(2)}}</span></p>
      </div>
      <a href="javascript:;" class="kaoshi_btn" @click="examPay(examPaperInfo, '0')">立刻购买</a>
    </div>
  </div>
</template>
<script>
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: { },
    data () {
      return {
        orgType: null,
        originPath: '',
        ori_str: '',
        examPaperInfo: {},
        examPaperQInfo: []
      }
    },
    created () {
      if (getCookie('org') && getCookie('org').businessId) { this.orgType=getCookie('org').businessId }
      this.getExamPaper(this.$route.params.id)
      this.ori_str = this.$utils.judgementOri(this.orgType)
      console.log(this.ori_str)
    },
    mounted () {
      this.$nextTick(() => {
      })
    },
    computed: {},
    methods: {
      getExamPaper (id) {
        this.$api.post(this.$global.examApiPath, '/examPaper/get', {id: id}, r => {
          if (r.data) {
            this.examPaperInfo = r.data[0]
            if (r.data[1] && r.data[1].length>0) {
              this.examPaperQInfo = r.data[1]
            }
          }
        })
      },
      examPay (examPaperInfo, type) {
        if (this.$TOKEN_VAL && this.$TOKEN_VAL!='') {
          let state = this.$utils.judgmentState(examPaperInfo.startDate, examPaperInfo.endDate)
          if (state=='0' || state=='2') {
            this.$api.post(this.$global.examApiPath, '/examPurchase/save', {paperId: examPaperInfo.id}, r => {
              if (r.data) {
                this.originPath = window.location.origin + '/#/' + this.ori_str + '/examReady/' + r.data.paperId + '/' + type
                this.$router.push({path: '/'+ this.ori_str +'/examPaperPay/'+ r.data.paperId + '/' + '4'+ '/'  + r.data.id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/'  + r.data.sign})
              }
            })
          } else if (state=='1') {
            this.$toasted.show('该考试已结束，无法进行购买！', {
              duration: 800
            })
          } else if (state=='-1') {
            this.$toasted.show('该考试开始时间或结束时间有误，无法进行购买！', {
              duration: 800
            })
          }
        } else {
          this.$toasted.show('请先登录！', {
            duration: 800
          })
        }
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/exam/about.vue